var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSentImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 131,
    viewBox: "0 0 198 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.317 5.23002C109.85 15.227 110.623 37.621 156.384 47.8038C192.871 55.9129 197.78 85.2738 195.991 101.457C195.137 109.183 184.41 136.29 165.649 128.82C101.969 103.448 22.287 151.755 17.3117 77.9436C15.3021 48.0026 19.83 -17.4834 82.317 5.23002Z",
    fill: "#F4EFFE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.66 86.2699L110.09 85.4499C111.92 84.1699 112.93 83.4399 112.93 83.4299L113.52 84.2399C113.52 84.2399 112.5 84.9899 110.66 86.2699Z",
    fill: "#8258F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.95 123.6C25.06 123.6 23.25 123.47 21.56 123.21L21.71 122.22C23.82 122.55 26.15 122.67 28.57 122.57L28.61 123.57C28.05 123.59 27.49 123.6 26.94 123.6H26.95ZM35.62 122.82L35.45 121.83C37.6 121.47 39.88 120.97 42.23 120.35L42.48 121.32C40.11 121.94 37.8 122.45 35.62 122.82ZM14.76 121.17C13.04 120.35 11.48 119.32 10.1 118.09C9.71 117.74 9.33 117.39 8.97 117.05L9.66 116.33C10.02 116.67 10.38 117.01 10.77 117.35C12.07 118.51 13.56 119.49 15.19 120.27L14.76 121.17ZM49.2 119.3L48.88 118.35C50.98 117.64 53.18 116.84 55.41 115.96L55.78 116.89C53.53 117.78 51.32 118.59 49.2 119.3ZM62.24 114.18L61.83 113.27C63.88 112.36 66 111.38 68.15 110.34L68.59 111.24C66.43 112.28 64.3 113.28 62.24 114.19V114.18ZM4.34 111.72C2.91 109.67 1.82 107.55 1.1 105.41L2.05 105.09C2.74 107.14 3.79 109.18 5.16 111.15L4.34 111.72ZM74.84 108.09L74.38 107.2C76.39 106.15 78.46 105.04 80.52 103.9L81 104.78C78.93 105.93 76.85 107.04 74.84 108.09ZM87.09 101.32L86.59 100.46C88.57 99.3101 90.58 98.1001 92.58 96.8801L93.1 97.7301C91.1 98.9501 89.08 100.16 87.09 101.32ZM1 98.4001L0 98.3801C0.04 96.0901 0.46 93.7301 1.25 91.3901L2.2 91.7101C1.44 93.9601 1.04 96.2101 1.01 98.4001H1ZM99.03 94.0301L98.49 93.1901C100.45 91.9401 102.42 90.6601 104.33 89.3801L104.88 90.2101C102.96 91.4901 100.99 92.7701 99.02 94.0301H99.03ZM5.15 85.5301L4.3 85.0001C5.47 83.1001 6.89 81.1901 8.51 79.3401L9.26 80.0001C7.68 81.8101 6.29 83.6701 5.15 85.5301Z",
    fill: "#8258F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.13 75.1299L13.47 74.3799C15.09 72.9599 16.18 72.1799 16.23 72.1499L16.81 72.9599C16.81 72.9599 15.71 73.7499 14.13 75.1299Z",
    fill: "#8258F3"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.82 23.1399L116.98 84.5799C115.15 86.1899 112.28 85.5999 111.24 83.3899L98.4001 56.1699",
    fill: "#B397F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.82 23.1399L116.28 85.1999C115.04 86.2899 113.09 85.5199 112.92 83.8799L110.94 64.1499L186.82 23.1399Z",
    fill: "url(#paint0_linear_0_1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.82 23.1399L143.96 80.0499C143.39 80.8099 142.34 81.0399 141.5 80.5899L110.95 64.1399L186.82 23.1399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.82 23.1399L78.1101 44.5199C77.8401 44.5699 77.7901 44.9299 78.0301 45.0599L98.4101 56.1699L186.82 23.1399Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: 73.8757,
    y: 19.1399,
    width: 120.945,
    height: 74.5674,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.0784314 0 0 0 0 0.368627 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 148.88,
    y1: 23.1399,
    x2: 148.88,
    y2: 85.7073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8258F3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 198.01,
    height: 107.6,
    fill: "white",
    transform: "translate(0 16)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentImage);
export default __webpack_public_path__ + "static/media/sent-image.e7a7c1ff7a740568f1801f346d4908c7.svg";
export { ForwardRef as ReactComponent };